import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCarouselComponent } from './custom-carousel.component';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';
import {IconModule, MediaModule} from '@spartacus/storefront';



@NgModule({
  declarations: [CustomCarouselComponent],
  exports: [CustomCarouselComponent],
  imports: [
    CommonModule,
    RouterModule, IconModule, MediaModule, UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CarouselComponent: {
          component: CustomCarouselComponent
        }
      }
    } as CmsConfig),
  ]
})
export class CustomCarouselModule { }
